import React from 'react';
import { Routes, Route } from 'react-router-dom';
import MainPage from './pages/Main/MainPage';





export default function AppRoutes() {
    return (
      <Routes>
          <Route path="/" element={<MainPage />} />

        {/* Public routes (no sidebar) */}
        {/* <Route >
          <Route path="/screens/:screenId" element={<ScreensPage/>} />
  
        </Route> */}
  
        {/* Private routes (with sidebar)
        <Route
          element={
            // If you’re using a ProtectedRoute to ensure user is logged in
            <ProtectedRoute>
              <PrivateLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<Home />} />
          <Route path="/roles" element={<Roles />} />
          <Route path='/orders' element={<Orders />} />
          <Route path="/products" element={<ProductsList />}/>
          <Route path="/modifiers/:productId" element={<ModifiersPage />} />
          <Route path="/organizations" element={<Organizations />} />
          <Route path="/organizations/:organizationId" element={<OneOrganization />} />
  
  
          {/* <Route path="/orders" element={<Orders />} /> */}
          {/* more private pages... */}
        {/* </Route> */} 
  
        {/* Fallback: if no route matches, go to /login */}
        {/* <Route path="*" element={<Login />} /> */}
      </Routes>
    );
  }
  